// extracted by mini-css-extract-plugin
export var center = "text-block-module--center--3K2Hv";
export var containerWidth = "text-block-module--container-width--ZV+71";
export var containerWidthWide = "text-block-module--container-width-wide--oCLIz";
export var left = "text-block-module--left--18hF0";